function speak (text) {
  if (!text) {
    return
  }

  var utterThis = new SpeechSynthesisUtterance(text);
  utterThis.lang = 'zh-cn'
  window.speechSynthesis.speak(utterThis);
}

export {
 speak
}